import { Skeleton } from '@/components/ui/skeleton';
import type { CatalogueView } from './view-toggle';

function CardSkeleton() {
  return (
    <div className="flex h-full flex-col overflow-hidden rounded-lg border border-border bg-card">
      <Skeleton className="aspect-[16/9] w-full rounded-none" />
      <div className="flex flex-col gap-3 p-4">
        <Skeleton className="h-3 w-24" />
        <Skeleton className="h-4 w-full" />
        <Skeleton className="h-4 w-3/4" />
        <Skeleton className="h-3 w-full" />
        <Skeleton className="h-3 w-5/6" />
        <div className="flex gap-2 pt-2">
          <Skeleton className="h-5 w-20 rounded-full" />
          <Skeleton className="h-5 w-16 rounded-full" />
        </div>
      </div>
    </div>
  );
}

function RowSkeleton() {
  return (
    <div className="flex gap-4 rounded-lg border border-border bg-card p-4">
      <Skeleton className="hidden h-20 w-32 shrink-0 sm:block" />
      <div className="flex flex-1 flex-col gap-2">
        <Skeleton className="h-3 w-28" />
        <Skeleton className="h-4 w-2/3" />
        <Skeleton className="h-3 w-full" />
        <Skeleton className="h-3 w-1/2" />
      </div>
    </div>
  );
}

export function LinkListSkeleton({ view, count = 6 }: { view: CatalogueView; count?: number }) {
  const items = Array.from({ length: count }, (_, index) => index);

  return (
    <div aria-hidden="true">
      {view === 'card' ? (
        <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3 2xl:grid-cols-4">
          {items.map((index) => (
            <CardSkeleton key={index} />
          ))}
        </div>
      ) : (
        <div className="flex flex-col gap-3">
          {items.map((index) => (
            <RowSkeleton key={index} />
          ))}
        </div>
      )}
    </div>
  );
}
